import phoneOTPRDPlusThemeTemplate from '../../templates/dialog/RDPlusTheme/phone_otp_template.ejs'
import phoneOTPTemplate from '../../templates/dialog/RDTheme/phone_otp_template.ejs'

const importOptinConsentTemplateFactory = (options = {}) => {
    if (ApexChat.IsRoundedDynamicPlusTheme) {
        return {
            optinConsentTemplate: phoneOTPRDPlusThemeTemplate(options),
        }
    }
    return {
        optinConsentTemplate: phoneOTPTemplate(options),
    };
};
export default importOptinConsentTemplateFactory;
